/**
 * Readouts: the numbers the system reports (counts, times, percentages).
 *
 * They wear the `.lcd` role (styles/primitives.css). The flat skin shows them
 * as they always were; a skin can show them on a sunk display whose unlit
 * segments stay faintly visible behind the lit ones, like a real LCD. Those
 * unlit segments are `data-ghost`: the same text with every digit lit, so it
 * lines up with the value character for character.
 *
 * ```tsx
 * <span className="lcd" data-ghost={lcdGhost('064/100')}>064/100</span>   // ghost «888/888»
 * ```
 */
export function lcdGhost(text: string | number): string {
  return String(text).replace(/[0-9]/g, '8')
}

/** Spread on a readout: its role class and its unlit segments. */
export function lcdProps(text: string | number): { className: string; 'data-ghost': string } {
  return { className: 'lcd', 'data-ghost': lcdGhost(text) }
}

/** A counter's digits: zero-padded to «digits», like a mechanical counter («012»). */
export function lcdCounter(n: number, digits = 3): string {
  return String(Math.max(0, Math.round(n))).padStart(digits, '0')
}
